import React from 'react'

const Top = () => {
  return (
    <svg
      viewBox="0 0 1441 38"
      version="1.1"
      preserveAspectRatio="xMinYMin meet"
    >
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <path
          d="M1441,0 L1441,28.2017775 C1238.33333,33.1572356 1095.66667,33.3016313 1013,28.6349647 C706.288092,11.3205828 585,16.6349647 417.005463,28.2017775 C241.489175,40.2864803 102.487354,40.2864803 0,28.2017775 L0,0 L1441,0 Z"
          fill={'white'} //"#EDF3FF"}
        />
      </g>
    </svg>
  )
}

export default Top
